<template>
  <b-overlay :show="show" rounded="md" :shown="shown()">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>

      <b-row align-h="center" style="width: 100%; margin-top: 60px">
        <b-col cols="12" style="padding-top: 5px" class="pl-0 pr-0 cart-nav">
          <b-row style="width: 100%">
            <b-col lg="6" class="pl-pr-0-sm hide-when-big">
              <b-row
                class="pl-3 pt-0 reduced_pl_pr"
                style="font-size: 28px; padding-bottom: 1px"
              >
                <b style="font-size: 33px; padding-bottom: 1px" class="h1-font"
                  >Truthbrush Hub</b
                >
              </b-row>
              <b-row class="mt-3">
                <b-col style="max-width: 500px" class="pl-pr-0-sm">
                  Connect your Truthbrush trackers to a WiFi signal with the
                  Truthbrush Hub. At least 1 Truthbrush hub is required. Add
                  additional hubs in or near the bathrooms where everyone likes
                  to brush.
                </b-col>
              </b-row>
            </b-col>

            <b-col
              lg="6"
              style="
                border-radius: 25px;
                border: 0px solid;
                padding-left: 0;
                padding-right: 0;
              "
              class=""
            >
              <b-row>
                <b-col class="pt-5 pb-5 pl-pr-0-sm reduced-pt-small">
                  <b-img
                    :src="selectedimage()"
                    fluid
                    rounded
                    center
                    style="max-width: 100%; max-height: 512px"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row class="pt-4 pl-3 pr-3 pl-pr-0-sm">
                <b-col
                  v-for="(item, index) in imagelist"
                  :key="index"
                  @mouseover="hoversample(index)"
                  class="pl-1 pr-1"
                  align-self="center"
                >
                  <b-img
                    :src="item"
                    fluid
                    rounded
                    :class="{ 'underline-blue': hoverindex == index }"
                    center
                    style=""
                  ></b-img>
                </b-col>
              </b-row>

              <b-row class="pt-5" style="justify-content: center">
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/worldwide.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Worldwide Shipping
                  </b-row>
                </b-col>

                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/fastdelivery.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Fast Delivery
                  </b-row>
                </b-col>
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/7dayreturn.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    30 Day Guarantee
                  </b-row>
                </b-col>
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/warranty.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Factory Warranty
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-1">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>
              <b-row class="pl-3 reduced_pl_pr hide-when-small">
                If you have any questions making selection, please
                <a href="/#/contact" style="padding-left: 6px"> contact us</a>
              </b-row>
            </b-col>

            <b-col lg="6" class="pl-pr-0-sm">
              <b-row
                class="pl-3 pt-5 reduced_pl_pr hide-when-small"
                style="font-size: 28px; padding-bottom: 1px"
                data-aos="fade-left"
                data-aos-delay="250"
              >
                <b style="font-size: 33px; padding-bottom: 1px" class="h1-font"
                  >Truthbrush Hub</b
                >
              </b-row>
              <b-row class="mt-3 hide-when-small">
                <b-col style="max-width: 500px" class="pl-pr-0-sm">
                  Connect your Truthbrush trackers to a WiFi signal with the
                  Truthbrush Hub. At least 1 Truthbrush hub is required. Add
                  additional hubs in or near the bathrooms where everyone likes
                  to brush.
                </b-col>
              </b-row>

              <b-row class="pt-1 hide-when-small">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row
                class="pl-3 pt-2 h3-font reduced_pl_pr"
                style="font-size: 22px; padding-bottom: 1px; font-weight: 700"
                data-aos="fade-left"
                data-aos-delay="350"
              >
                Please select your model
              </b-row>
              <b-row
                class="pl-3 pt-0 reduced_pl_pr"
                style="font-size: 22px; padding-bottom: 10px"
                data-aos="fade-left"
                data-aos-delay="450"
              >
                <a href="#/select"
                  >Are you looking for tracker or a tracker+hub bundle？</a
                >
              </b-row>

              <b-row class="pl-3 pt-3 reduced_pl_pr">
                <b-col
                  :class="getSelectProductClass(0)"
                  style="max-width: 500px; cursor: pointer"
                  @click="clicksku(0)"
                >
                  <b-row class="pt-2 pb-2">
                    <b-col cols="9" class="reduced_pl_pr">
                      <b-row>
                        <b style="font-size: 24px" class="h3-font"
                          >Truthbrush Hub</b
                        >
                      </b-row>
                      <b-row class="pt-2">
                        Truthbrush Hub with USB plug. Automatically connects with multiple trackers. Adaptor not included.
                      </b-row>
                    </b-col>
                    <b-col cols="3" class="reduced_pl_pr">
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 0) }}</b
                        >
                      </b-row>
                      <b-row
                        class="pt-2"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(true, false, 0) -
                            getBundlePrice(true, true, 0) ==
                          0
                        "
                      >
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(true, false, 0) -
                            getBundlePrice(true, true, 0) ==
                          0
                        "
                      >
                      </b-row>
                      <b-row
                        class="pt-2"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(true, false, 0) -
                            getBundlePrice(true, true, 0) >
                          0
                        "
                      >
                        <s style='text-align:right'> was $ {{ getBundlePrice(true, false, 0) }}</s>
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end; color: #12b8ed"
                        v-if="
                          getBundlePrice(true, false, 0) -
                            getBundlePrice(true, true, 0) >
                          0
                        "
                      >
                        <b style='text-align:right'
                          >save $
                          {{
                            (
                              getBundlePrice(true, false, 0) -
                              getBundlePrice(true, true, 0)
                            ).toFixed(2)
                          }}</b
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pl-3 pt-3 reduced_pl_pr">
                <b-col
                  :class="getSelectProductClass(1)"
                  style="max-width: 500px; cursor: pointer"
                  @click="clicksku(1)"
                >
                  <b-row class="pt-2 pb-2">
                    <b-col cols="9" class="reduced_pl_pr">
                      <b-row>
                        <b style="font-size: 24px" class="h3-font"
                          >Hub + Adaptor (US)</b
                        >
                      </b-row>
                      <b-row class="pt-2">
                        Add a Type A compatible USB power adapter to conveniently plug into a wall outlet (For US, Canada, Mexico, Others)
                      </b-row>
                    </b-col>
                    <b-col
                      cols="3"
                      class="reduced_pl_pr"
                      v-if="
                        getBundlePrice(false, false, 1) -
                          getBundlePrice(true, true, 1) >
                        0.000001
                      "
                    >
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 1) }}</b
                        >
                      </b-row>
                      <b-row class="pt-2" style="justify-content: flex-end">
                        <s style='text-align:right'>was $ {{ getBundlePrice(false, false, 1) }}</s>
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end; color: #12b8ed"
                      >
                        <b style='text-align:right'
                          >save $
                          {{
                            (
                              getBundlePrice(false, false, 1) -
                              getBundlePrice(true, true, 1)
                            ).toFixed(2)
                          }}</b
                        >
                      </b-row>
                    </b-col>
                    <b-col cols="3" class="reduced_pl_pr" v-else>
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 1) }}</b
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pl-3 pt-3 reduced_pl_pr">
                <b-col
                  :class="getSelectProductClass(2)"
                  style="max-width: 500px; cursor: pointer"
                  @click="clicksku(2)"
                >
                  <b-row class="pt-2 pb-2">
                    <b-col cols="9" class="reduced_pl_pr">
                      <b-row>
                        <b style="font-size: 24px" class="h3-font"
                          >Hub + Adaptor (AU)</b
                        >
                      </b-row>
                      <b-row class="pt-2">
                        Add a Type I compatible USB power adapter to conveniently plug into a wall outlet (For Australia, Others)
                      </b-row>
                    </b-col>
                    <b-col
                      cols="3"
                      class="reduced_pl_pr"
                      v-if="
                        getBundlePrice(false, false, 1) -
                          getBundlePrice(true, true, 1) >
                        0.000001
                      "
                    >
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 1) }}</b
                        >
                      </b-row>
                      <b-row class="pt-2" style="justify-content: flex-end">
                        <s style='text-align:right'>was $ {{ getBundlePrice(false, false, 1) }}</s>
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end; color: #12b8ed"
                      >
                        <b style='text-align:right'
                          >save $
                          {{
                            (
                              getBundlePrice(false, false, 1) -
                              getBundlePrice(true, true, 1)
                            ).toFixed(2)
                          }}</b
                        >
                      </b-row>
                    </b-col>
                    <b-col cols="3" class="reduced_pl_pr" v-else>
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 1) }}</b
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="pt-4 pb-3 pl-3 reduced_pl_pr">
                <b style="font-size: 24px" class="h3-font">{{
                  getproductInfo()
                }}</b>
              </b-row>
              <b-row class="pt-2">
                <b-col md="12" class="reduced_pl_pr">
                  <b-button
                    pill
                    class="full-width blue-button"
                    v-if="stock > 0 && selectedQuantity <= stock"
                    v-on:click="onAddCart()"
                  >
                    <span style="font-size: 18px">Add to Cart</span>
                  </b-button>
                  <b-button
                    pill
                    disabled
                    style="
                      background-color: #12b8ed;
                      border: none;
                      padding: 10px 30px;
                    "
                    v-else
                  >
                    <span class="">Add to Cart</span>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="pt-2 pb-3 pl-3 reduced_pl_pr">
                <b-col
                  class="col-2 reduced_pl_pr pl-0 pr-0"
                  align-self="center"
                >
                  <b-img
                    src="img/box1.png"
                    style="height: 48px; height: 48px"
                  ></b-img>
                </b-col>
                <b-col align-self="center">
                  <b-row style="justify-content: left" class="pt-2">
                    Free US shipping for $50 or above. Worldwide Shipping.
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row
            style="width: 100%; position: relative; padding-bottom: 60px"
            align-h="center"
            class="main-jumbotron reduced-pb-0 pt-5" hidden
          >
            <b-col md="6" cols="12" class="hub-col-wrapper pt-3">
              <b-img src="img/products/hub_6.jpg" fluid></b-img>
            </b-col>
            <b-col
              md="6"
              cols="12"
              class="hub-col-wrapper pt-3"
              align-self="center"
            >
              <b-row>
                <b-col
                  class=""
                  style="font-size: 24px; font-weight: 600; color: #12b8ed"
                >
                  Standard Hub
                </b-col>
              </b-row>

              <b-row class="pt-3 pb-3">
                <b-col>
                  <h1 style="max-width: 820px; color: black; max-width: 500px">
                    Connects any Truthbrush Trackers to Wi-Fi internet
                  </h1>
                </b-col>
              </b-row>
              <b-row class="pt-3">
                <b-col>
                  <b-img
                    src="img/multitracker_icon.jpg"
                    style="width: 30px; margin-right: 10px"
                  ></b-img>
                  <p style="font-size: 18px; font-weight: 600; display: inline">
                    Supports multiple trackers
                  </p>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col>
                  <b-img
                    src="img/uploaddata_icon.jpg"
                    style="width: 30px; margin-right: 10px"
                  ></b-img>
                  <p style="font-size: 18px; font-weight: 600; display: inline">
                    Uploads data automatically
                  </p>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col>
                  <b-img
                    src="img/type_a_icon.jpg"
                    style="width: 30px; margin-right: 10px"
                  ></b-img>
                  <p style="font-size: 18px; font-weight: 600; display: inline">
                    US/Canada type A plug
                  </p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row
            style="width: 100%; position: relative; padding-bottom: 60px"
            align-h="center"
            class="main-jumbotron reduced-pb-0 pt-5"
          >
            <b-col md="6" cols="12" class="hub-col-wrapper pt-3 hide-when-big">
              <b-img src="img/products/travel_hub_4.jpg" fluid></b-img>
            </b-col>
            <b-col
              md="6"
              cols="12"
              class="hub-col-wrapper pt-3"
              align-self="center"
            >
              <b-row>
                <b-col
                  class=""
                  style="font-size: 24px; font-weight: 600; color: #12b8ed"
                >
                  Truthbrush Hub
                </b-col>
              </b-row>

              <b-row class="pt-3 pb-3">
                <b-col>
                  <h1 style="max-width: 820px; color: black; max-width: 500px">
                    Lightweight design. Same performance.
                  </h1>
                </b-col>
              </b-row>
              <b-row class="pt-3">
                <b-col>
                  <b-img
                    src="img/usb_icon.jpg"
                    style="width: 30px; margin-right: 10px"
                  ></b-img>
                  <p style="font-size: 18px; font-weight: 600; display: inline">
                    Standard USB connector
                  </p>
                </b-col>
              </b-row>
              <b-row class="pt-3">
                <b-col>
                  <b-img
                    src="img/travel_icon.jpg"
                    style="width: 30px; margin-right: 10px"
                  ></b-img>
                  <p style="font-size: 18px; font-weight: 600; display: inline">
                    Easy to carry while traveling
                  </p>
                </b-col>
              </b-row>
              <b-row class="pt-3">
                <b-col>
                  <b-img
                    src="img/multitracker_icon.jpg"
                    style="width: 30px; margin-right: 10px"
                  ></b-img>
                  <p style="font-size: 18px; font-weight: 600; display: inline">
                    Supports multiple trackers
                  </p>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col>
                  <b-img
                    src="img/uploaddata_icon.jpg"
                    style="width: 30px; margin-right: 10px"
                  ></b-img>
                  <p style="font-size: 18px; font-weight: 600; display: inline">
                    Uploads data automatically
                  </p>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              md="6"
              cols="12"
              class="hub-col-wrapper pt-3 hide-when-small"
            >
              <b-img src="img/products/travel_hub_4.jpg" fluid></b-img>
            </b-col>
          </b-row>

          <b-row class="pt-5">
            <b-col class="pl-0 pr-0">
              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%" class="h1-font">
                  Technical Specification
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  pt-2
                  pl-3
                  pr-3
                  h4-font
                "
                style="
                  max-width: 700px;
                  margin: auto !important;
                  font-size: 18px;
                "
              >
                Datasheet and Specification
              </b-row>

              <b-row class="pt-5">
                <b-col cols="12" md="12" class="pb-5 reduced_pl_pr">
                  <b-row>
                    <b-col class="reduced_pl_pr">
                      <b-img
                        src="/img/travel_hub_illustration.jpg"
                        center
                        style="max-height: 360px; max-width: 100%"
                        class="image-side-2-side"
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row
                    style="
                      justify-content: center;
                      font-size: 22px;
                      padding-top: 20px;
                    "
                    class="h4-font"
                  >
                    Truthbrush Hub
                  </b-row>
                </b-col>
                <b-col cols="6" md="6" class="reduced_pl_pr" hidden>
                  <b-row>
                    <b-col class="reduced_pl_pr">
                      <b-img
                        src="/img/hub_illustration.jpg"
                        center
                        style="max-height: 360px; max-width: 100%"
                        class="image-side-2-side"
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row
                    style="
                      justify-content: center;
                      font-size: 22px;
                      padding-top: 20px;
                    "
                    class="h4-font"
                  >
                    Standard Hub
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-0 pl-5 pr-5 reduced_pl_pr">
                <b-col cols="12">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="pt-3 spec">
                <b-col cols="12" class="pl-pr-0-sm">
                  <b-row>
                    <b-col cols="12">
                      <b>Input</b>
                    </b-col>
                    <b-col cols="12"> USB 5v DC 500mA</b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Plug type</b>
                    </b-col>
                    <b-col cols="12"> USB </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Working distance</b>
                    </b-col>
                    <b-col cols="12"> 30 feet (clear distance)</b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Multiple tracker support</b>
                    </b-col>
                    <b-col cols="12"> Yes </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Wireless protocal</b>
                    </b-col>
                    <b-col cols="12">
                      Wi-Fi 2.4GHz, WPA1/WPA2, Bluetooth
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="6" class="pl-pr-0-sm" hidden>
                  <b-row>
                    <b-col cols="12">
                      <b>Input</b>
                    </b-col>
                    <b-col cols="12"> 110-240v </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Plug type</b>
                    </b-col>
                    <b-col cols="12"> US Type-A </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Working distance</b>
                    </b-col>
                    <b-col cols="12"> 50 feet </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Multiple tracker support</b>
                    </b-col>
                    <b-col cols="12"> Yes </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Wireless protocol</b>
                    </b-col>
                    <b-col cols="12"> WiFi 2.4GHz, WPA1/WPA2, Bluetooth </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="justify-content: center" class="pt-5">
                <a href="/#/product">Additional information</a>
              </b-row>
              <b-row class="pt-3 pl-5 pr-5 reduced_pl_pr">
                <b-col cols="12">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%; text-align: center" class="h1-font">
                  Frequently Asked Questions
                </h1>
              </b-row>
              <b-row class="pl-5 pr-5 reduced_pl_pr">
                <VueFaqAccordion
                  :items="myItems"
                  :activeColor="activeColorAccordian"
                  :borderColor="borderColorAccordian"
                />
              </b-row>
              <b-row style="justify-content: center" class="pt-5 pb-5">
                <a href="/#/faq">Visit our FAQ section</a>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>

      <b-row>
        <Checkout-Express id="my-modal" ref="my-modal"> </Checkout-Express>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import storage from "../storage";
import store from "../store";
import VueFaqAccordion from "vue-faq-accordion";
import CheckoutExpress from "./../components/CheckoutExpress";

import env from "../env";
export default {
  name: "ProductSelect",
  components: {
    NavHeader,
    NavFooter,
    VueFaqAccordion,
    CheckoutExpress,
  },
  data() {
    return {
      show: false,
      aspect: "1:1",
      selectedindex: 1,
      hoverindex: 0,
      selectedproduct: 0,
      selectedstyle1: 0,
      selectedstyle2: 1,
      selectedstyle3: 2,
      selectedstyle4: 3,

      selectedstyle1open: false,
      selectedstyle2open: false,
      selectedstyle3open: false,
      selectedstyle4open: false,

      t1rating: 0,
      t2rating: 0,
      t1count: 0,
      t2count: 0,

      stock: 9999,
      imagelist: [],
      paginationColor: "#12B8ED",
      activeColorAccordian: "#000000",
      borderColorAccordian: "#d9dadb",
      extrasensorclass: [false, false, false, false, false, false, false],
      myItems: [
        {
          title:
            "1. What is the Truthbrush hub?",
          value:
            "After every brushing event, the Truthbrush hub automatically receives brushing data from your tracker - without pushing any buttons; without needing your phone to be present. The Truthbrush hub safely and securely connects to your home WiFi and the Truthbrush servers in the cloud. Software on the hub uses industry leading security protocols to encrypt all data for maximum privacy protection. The Truthbrush hub needs to be within 30 ft of your Truthbrush trackers.",
        },
        {
          title:
            "2. Does the hub work with both the tracker and tracker Pro?",
          value: "Yes, the Truthbrush hub is compatible with both the Truthbrush Classic and the Truthbrush Pro trackers.",
        },
        {
          title:
            "3. Do I need more than one hub?",
          value:
            "The hub is designed to accommodate multiple Truthbrush trackers. The hub will collect data from all trackers within 30 ft. Multiple hubs can be used in large homes where the bathrooms might be spread out.",
        },
        {
          title:
            "4. Why can't I simply connect the tracker to my mobile phone?",
          value: "The Truthbrush Connected Oral Care system is designed differently to easily and effortlessly enable you to track your oral care behaviors with no extra steps; with no buttons to push and without the need to have a phone present. The Truthbrush's patented design allows you to capture almost 100% of the data showing what you are doing well and the opportunities you have to improve. Our customers have told us that they don't want to have to fight with clumsy bluetooth connections that frequently have to be reestablished. Many of our customers don't want to have to take their phone in the bathroom with them. And, even more of our customers do not want to give their expensive mobile phones to their children to take to the bathroom. We personally think we should not introduce a bad habit (more screen time) while teaching a good habit.",
        },
      ],
      productname: "",
      stripe: null,
      selectedQuantity: "1",
      optionsQuantity: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  methods: {
    getBundlePrice(bundle, applycoupon, index) {
      var obj = [];
      if (index == 0) {
        obj.push({ sku: store.state.inventory.standardhub, quantity: 1 });
      } else if (index == 1) {
        obj.push({ sku: store.state.inventory.travelhub, quantity: 1 });
        let adaptor_us = store.state.inventory.adaptor_us;
        obj.push({ sku: adaptor_us, quantity: 1 });
      } else if (index == 2) {
        obj.push({ sku: store.state.inventory.travelhub, quantity: 1 });
        let adaptor_au = store.state.inventory.adaptor_au;
        obj.push({ sku: adaptor_au, quantity: 1 });
      }
      return storage.calculateBundleDiscount(bundle, applycoupon, obj);
    },
    getproductInfo() {
      var prodname = "";

      if (this.selectedproduct == 0) {
        prodname = "1 Hub";
        return (
          prodname +
          " $" +
          this.getBundlePrice(true, store.state.discount_percent > 0, 0)
        );
      } else if (this.selectedproduct == 1) {
        prodname = "1 Hub with Adaptor (US)";
        return (
          prodname +
          " $" +
          this.getBundlePrice(true, store.state.discount_percent > 0, 1)
        );
      } else if (this.selectedproduct == 2) {
        prodname = "1 Hub with Adaptor (AU)";
        return (
          prodname +
          " $" +
          this.getBundlePrice(true, store.state.discount_percent > 0, 1)
        );
      }
    },
    getSelectProductClass(index) {
      //console.log(index + " " + this.selectedproduct);
      if (this.selectedproduct == index) {
        return "product-select-box2";
      }
      return "product-select-box";
    },
    setUnderline(index, val) {
      this.extrasensorclass = [false, false, false, false, false, false, false];
      this.extrasensorclass[index] = val;
    },

    onAddCart() {
      var list = [];
      if (this.selectedproduct == 0) {
        let sku = store.state.inventory.travelhub;
        sku.metadata = {};
        sku.metadata.image0 = sku.images[0];
        list.push({ sku: sku, quantity: 1 });
      } else if (this.selectedproduct == 1) {
        let sku = store.state.inventory.travelhub;
        sku.metadata = {};
        sku.metadata.image0 = sku.images[0];
        list.push({ sku: sku, quantity: 1 });

        let adaptor_us = store.state.inventory.adaptor_us;
        adaptor_us.metadata = {};
        adaptor_us.metadata.image0 = adaptor_us.images[0];
        list.push({ sku: adaptor_us, quantity: 1 });
      } else if (this.selectedproduct == 2) {
        let sku = store.state.inventory.travelhub;
        sku.metadata = {};
        sku.metadata.image0 = sku.images[0];
        list.push({ sku: sku, quantity: 1 });

        let adaptor_au = store.state.inventory.adaptor_au;
        adaptor_au.metadata = {};
        adaptor_au.metadata.image0 = adaptor_au.images[0];
        list.push({ sku: adaptor_au, quantity: 1 });
      }
      storage.onAddCart(list, this);
    },

    clicksku(index) {
      if (index == null) {
        return this.clicksku(this.selectedproduct);
      }
      this.selectedproduct = index;
      this.populationImageView(index);
      this.hoversample(0);
    },
    populationImageView(productindex) {
      this.imagelist = [];
      if (productindex == 0) {
        this.imagelist = store.state.inventory.travelhub.images.slice();
      } else if (productindex == 1) {
        this.imagelist = store.state.inventory.travelhub.images.slice();
        this.imagelist[0] = "img/products/hub_adaptor_type_1.jpg";
        this.imagelist[2] = "img/products/adaptor_us.png";
      } else if (productindex == 2) {
        this.imagelist = store.state.inventory.travelhub.images.slice();
        this.imagelist[0] = "img/products/hub_adaptor_type_i.jpg";
        this.imagelist[2] = "img/products/adaptor_au.png";
      }
    },
    hoversample(index) {
      this.selectedindex = index;
      this.hoverindex = index;
      this.selectedimage();
    },
    selectedimage() {
      if (this.selectedindex < this.imagelist.length) {
        return this.imagelist[this.selectedindex];
      }
    },

    shown() {},
  },
  mounted() {
    var context = this;
    //context.show = true;

    var stripekey = env.stripe_public_key;
    this.$loadScript(
      "https://js.stripe.com/v3/" // production
    ).then(() => {
      //console.log("stripe loaded");
      context.stripe = window.Stripe(stripekey, {
        apiVersion: "2020-08-27",
      });
    });

    this.$loadScript("https://www.paypalobjects.com/api/checkout.js").then(
      () => {}
    );

    storage.clearstorestate();
    //storage.populateSku(this,2);
    storage.processCoupon();
    storage.saveCart2Store(this);
    this.clicksku(0);
  },
};
</script>

<style lang="scss">
.hub-col-wrapper {
  padding-left: 5%;
  padding-right: 5%;
}

.abouthero {
  background-color: black;
}
.spec .col-12 {
  text-align: center;
}
@media (max-width: 768px) {
  .padding-top-when-small {
    padding-top: 15px;
  }
  .pl-pr-0-sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (max-width: 1199px) {
  .aboutmaintext {
    color: black;
    font-size: 20px;
    padding-left: 5%;
    padding-right: 5%;
  }
  .featuretitle {
    font-size: 20px !important;
    padding-bottom: 10px;
  }
  .featuredescription {
    color: #696871;
    font-size: 14px !important;
    padding-bottom: 25px;
  }
  .no-v-padding-small {
    padding-top: 0 !important;
  }
  .reduce-font-small {
    font-size: 24px !important;
  }
}
@media (max-width: 768px) {
  .hub-col-wrapper {
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  .reduced-pt-small {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .trackerfeature,
  .trackerfeature > .row > .col-sm-6 > .row > .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .reduced-padding-top {
    padding-top: 30px !important;
  }
  .trackerfeature > .row > .col-md-6 > .row > .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (min-width: 1200px) {
  .aboutmaintext {
    color: black;
    font-size: 24px;
    padding-left: 15%;
    padding-right: 15%;
  }
}
.productcell {
  border-radius: 20px;
  background-color: #f0f4f5;
  width: 100%;
  height: 100%;
}
.productcellwhole:hover {
  border: 2px solid #2ebfde !important;
  cursor: pointer;
  border-radius: 20px;
}
.productcellwhole {
  border: 2px solid white !important;
  cursor: pointer;
  border-radius: 20px;
}
.activesku {
  border: 3px solid #2ebfde !important;
  border-radius: 20px !important;
}
.inactivesku {
  border: 3px solid transparent;
  border-radius: 20px !important;
  padding: 5%;
}
.position-absolute {
  position: fixed !important;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
.featuretitle {
  color: #19191b;
  font-size: 24px;
  padding-bottom: 10px;
}
.featuredescription {
  color: #696871;
}
.breadcrumb-item a {
  color: #05c5ee;
}
.breadcrumb-item {
  font-size: 16px;
}
.breadcrumb {
  background-color: transparent !important;
}
.overlay-blur {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
  color: rgba(130, 130, 130, 0.5);
  font-size: 50px;
  text-align: center;
  line-height: 100px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
}
.underline-blue {
  border: 2px solid;
  border-color: #05c5ee;
  padding: 0px;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
@media (max-width: 1199px) {
  .cart-nav {
    padding: 0.5rem 15px !important;
  }
  .hide-when-small-1200 {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .cart-nav {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
  }
  .hide-when-big-1200 {
    display: none;
  }
}
@media only screen and (min-width: 1440px) {
  .cart-nav {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
  }
  .b-nav-dropdown ul {
    display: none !important;
  }
}
.breadcrumb {
  padding-left: 0.5rem;
}
a {
  color: #12b8ed;
}
.product-select-box {
  border-radius: 5px;
  border: 4px solid;
  border-color: #bdbdbd;
  background-color: white;
}
.product-select-box2 {
  border-radius: 5px;
  border: 4px solid;
  border-color: #12b8ed;
  background-color: white;
}
hr {
  border-top: 1px solid #bdbdbd;
}
.faq-wrapper {
  max-width: 100% !important;
}
.accordion {
  border: 0px solid !important;
}
.accordion__title-text {
  font-size: 24px !important;
  text-align: left !important;
}
@media (max-width: 768px) {
  #my-modal {
    padding-left: 0 !important;
  }

  .reduced_pl_pr {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .accordion__title {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .h1-font {
    font-size: 28px !important;
    font-weight: 600 !important;
  }
  .h2-font {
    font-size: 24px !important;
  }
  .h3-font {
    font-size: 20px !important;
    font-weight: 600 !important;
  }
  .h4-font {
    font-size: 16px !important;
    text-align: left !important;
    width: 100%;
  }
  .accordion__title-text {
    font-size: 16px !important;
    text-align: left !important;
  }
  .image-side-2-side {
    max-height: 200px !important;
    max-width: 50%;
  }
  .full-width {
    width: 100% !important;
  }
  .accordion__toggle-button {
    text-align: left !important;
  }
}
.blue-button,
.blue-button:hover {
  background-color: #12b8ed;
  border: none;
  padding: 12px 60px;
}

.full-width.blue-button {
  width: 100%;
  max-width: 500px;
  height: 60px;

  span {
    font-size: 18px;
  }
}

.underlinestyle {
  border-bottom: 2px solid #12b8ed;
}

.modal-backdrop {
  opacity: 0.85 !important;
}
</style>